/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaxCheckAddress
 */
export interface PaxCheckAddress {
    /**
     * 
     * @type {string}
     * @memberof PaxCheckAddress
     */
    lineOne?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckAddress
     */
    lineTwo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckAddress
     */
    lineThree?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckAddress
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckAddress
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckAddress
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckAddress
     */
    countryCode?: string | null;
}

/**
 * Check if a given object implements the PaxCheckAddress interface.
 */
export function instanceOfPaxCheckAddress(value: object): value is PaxCheckAddress {
    return true;
}

export function PaxCheckAddressFromJSON(json: any): PaxCheckAddress {
    return PaxCheckAddressFromJSONTyped(json, false);
}

export function PaxCheckAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'lineOne': json['lineOne'] == null ? undefined : json['lineOne'],
        'lineTwo': json['lineTwo'] == null ? undefined : json['lineTwo'],
        'lineThree': json['lineThree'] == null ? undefined : json['lineThree'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
    };
}

export function PaxCheckAddressToJSON(json: any): PaxCheckAddress {
    return PaxCheckAddressToJSONTyped(json, false);
}

export function PaxCheckAddressToJSONTyped(value?: PaxCheckAddress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lineOne': value['lineOne'],
        'lineTwo': value['lineTwo'],
        'lineThree': value['lineThree'],
        'city': value['city'],
        'state': value['state'],
        'postalCode': value['postalCode'],
        'countryCode': value['countryCode'],
    };
}

